import assign from 'lodash/assign';

import constants from '../constants';
import Listing from '../../models/Listing';

const initState = () => ({
  listing: Listing(),
  propertyRating: '',
  propertyReview: '',
  propertyManagerRating: '',
  propertyManagerReview: '',
  tenantType: '',
});

const ratingAndReview = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.SET_RATING_AND_REVIEW_LISTING) {
    return assign({}, state, {
      listing: Listing(payload),
    });
  } else if (type === constants.EDIT_PROPERTY_RATING) {
    return assign({}, state, {
      propertyRating: Number(payload),
    });
  } else if (type === constants.EDIT_PROPERTY_REVIEW) {
    return assign({}, state, {
      propertyReview: String(payload),
    });
  } else if (type === constants.EDIT_MANAGER_RATING) {
    return assign({}, state, {
      propertyManagerRating: Number(payload),
    });
  } else if (type === constants.EDIT_TENANT_TYPE) {
    return assign({}, state, {
      tenantType: String(payload),
    });
  } else if (type === constants.EDIT_MANAGER_REVIEW) {
    return assign({}, state, {
      propertyManagerReview: String(payload),
    });
  } else {
    return state;
  }
};

export default ratingAndReview;
